import axios from 'src/api/Api';
import { put } from 'redux-saga/effects';
import {
    GET_OVERRIDE_REASONS_SUCCESS,
    GET_OVERRIDE_REASONS_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* getOverrideReasonsData(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const url = `/occ/v2/${baseSiteId}/order/priceoverridereasons`;

    const { fields = 'DEFAULT', orderType = 'ZLB' } = action.payload || {};

    try {
        const response = yield axios.get(url, {
            params: { fields, orderType },
        });
        yield put({ type: GET_OVERRIDE_REASONS_SUCCESS, data: response.data });
    } catch (error) {
        yield put({
            type: GET_OVERRIDE_REASONS_FAILURE,
            data: errorHandler(error),
        });
        logUiErrorToBackend('getOverrideReasonsData', error);
    }
}
